module.exports = __webpack_public_path__ + "static/media/Question Icon.fe6692cd.svg";